import clsx from 'clsx';

export interface IconErrorProps {
  className?: string;
}

const IconError = ({ className }: IconErrorProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      'transition-all duration-300 motion-reduce:transition-none',
      className,
    )}
  >
    <path d="M12.9932 19.4C13.3312 19.4 13.6169 19.2857 13.8502 19.057C14.0835 18.8284 14.2002 18.545 14.2002 18.207C14.2002 17.869 14.0859 17.5833 13.8572 17.35C13.6286 17.1167 13.3452 17 13.0072 17C12.6692 17 12.3835 17.1143 12.1502 17.343C11.9169 17.5716 11.8002 17.855 11.8002 18.193C11.8002 18.531 11.9145 18.8167 12.1432 19.05C12.3718 19.2833 12.6552 19.4 12.9932 19.4ZM11.8002 14.6H14.2002V6.60001H11.8002V14.6ZM13.0094 25.8C11.2477 25.8 9.58908 25.4667 8.03353 24.8C6.47797 24.1333 5.11686 23.2167 3.9502 22.05C2.78353 20.8833 1.86686 19.5227 1.2002 17.9681C0.533529 16.4134 0.200195 14.7523 0.200195 12.9847C0.200195 11.2171 0.533529 9.56112 1.2002 8.01668C1.86686 6.47224 2.78353 5.11668 3.9502 3.95001C5.11686 2.78335 6.47751 1.86668 8.03213 1.20001C9.58677 0.533346 11.2479 0.200012 13.0155 0.200012C14.7831 0.200012 16.4391 0.533346 17.9835 1.20001C19.528 1.86668 20.8835 2.78335 22.0502 3.95001C23.2169 5.11668 24.1335 6.47472 24.8002 8.02415C25.4669 9.57359 25.8002 11.2291 25.8002 12.9908C25.8002 14.7525 25.4669 16.4111 24.8002 17.9667C24.1335 19.5222 23.2169 20.8833 22.0502 22.05C20.8835 23.2167 19.5255 24.1333 17.9761 24.8C16.4266 25.4667 14.7711 25.8 13.0094 25.8ZM13.0002 23.4C15.8891 23.4 18.3446 22.3889 20.3669 20.3667C22.3891 18.3445 23.4002 15.8889 23.4002 13C23.4002 10.1111 22.3891 7.65557 20.3669 5.63335C18.3446 3.61112 15.8891 2.60001 13.0002 2.60001C10.1113 2.60001 7.65575 3.61112 5.63353 5.63335C3.61131 7.65557 2.6002 10.1111 2.6002 13C2.6002 15.8889 3.61131 18.3445 5.63353 20.3667C7.65575 22.3889 10.1113 23.4 13.0002 23.4Z" />
  </svg>
);

export default IconError;
